import { createStore } from 'vuex';

import errorModule from './modules/error';
import spidInfoModule from './modules/spidinfo';


const store = createStore({
    modules: {
        error: errorModule,
        spidInfo: spidInfoModule
    }
});

export default store;
